<template>
  <div>
    <!-- <b-container class="p-relative">
      <div
        class="header-text-container"
        :style="isMobile ? 'top: 75px' : ''"
        v-if="showHeader"
      >
        <div class="header-text">{{ $route.params.name }}</div>
      </div>
      <div class="header-actions-container" :style="isMobile ? 'left: 0' : ''">
        <search-all
          v-show="!isMobile"
          @open="showHeader = isMobile ? false : true"
          @close="showHeader = true"
        />

        <br v-show="isMobile" />

        <b-button
          class="py-2 mx-3 border-0"
          :class="isMobile ? 'small-btn px-0' : 'px-3'"
          @click="
            $router.push({
              name: 'board.new-main-board-page',
              params: {
                id: $route.params.id,
                name: $route.params.name
              }
            })
          "
        >
          <b-img
            width="12"
            class="rounded-0 mr-2"
            :src="require('@/assets/icons/plus.svg')"
          ></b-img>
          <b>Main Switch Board</b>
        </b-button>

        <b-button
          class="py-2 border-0"
          :class="isMobile ? 'small-btn px-0' : 'px-3'"
          disabled
        >
          <b-img
            width="12"
            class="rounded-0 mr-2"
            :src="require('@/assets/icons/plus.svg')"
          ></b-img>
          <b>Distribution Board</b>
        </b-button>
      </div>
    </b-container> -->

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <div class="subheader-container">
      <b-container class="p-relative">
        <div class="subheader-text-container">
          <b-breadcrumb
            :items="items"
            class="pl-0 bg-transparent"
          ></b-breadcrumb>
        </div>
      </b-container>
    </div>

    <b-container class="py-0 pt-5" :class="isMobile ? '' : 'custom-container'">
      <div class="d-flex justify-content-between mb-5">
        <h2>
          <b>Changelog</b>
        </h2>

        <b-link
          v-show="changelog.data && changelog.data.length"
          class="toggle-btn"
          v-b-toggle="'changelog'"
          @click="isOpen = !isOpen"
          >Minimise all {{ isOpen ? '-' : '+' }}</b-link
        >
      </div>

      <p
        class="text-center font-italic"
        v-show="!isLoading && !(changelog.data && changelog.data.length)"
      >
        No changelog to show.
      </p>

      <div
        class="accordion mt-4 mb-5 shadow-none"
        role="tablist"
        v-show="changelog.data && changelog.data.length"
        v-for="(data, index) in changelog.data"
        :key="index"
      >
        <b-card
          no-body
          class="mb-3 shadow-none"
          style="border: 1px solid rgba(0, 0, 0, 0.125);"
        >
          <b-card-header
            header-tag="header"
            class="py-3 c-pointer d-flex"
            role="tab"
            v-b-toggle="`changelog`"
            @click="isOpen = !isOpen"
          >
            <span class="text-muted">{{ data.date }}</span>
            <span class="mx-2 text-muted">•</span>
            <span class="text-muted">{{ $route.params.name }}</span>
          </b-card-header>

          <b-collapse visible role="tabpanel" id="changelog">
            <b-card-body>
              <b-card-text>
                <b-list-group class="mb-3">
                  <b-list-group-item
                    v-for="item in data.logs"
                    :key="item.id"
                    class="border-0 px-0"
                  >
                    <div class="d-flex">
                      <div class="log__number">
                        <span class="mr-3"> <b>CB NO.</b></span>
                      </div>
                      <div class="log__details d-flex flex-column">
                        <div class="log__details__description">
                          <span class="mr-3">
                            <b>
                              {{
                                item.group.cb_nos.length
                                  ? item.group.cb_nos.join(', ')
                                  : item.cb_no
                              }}
                            </b>
                          </span>
                          <span>
                            {{ setDescription(item.description) }}
                          </span>
                          <span
                            class="changelog__value"
                            v-show="
                              !item.description.includes('Removed') &&
                                item.from &&
                                !item.description.includes('Circuits ungrouped')
                            "
                            >{{ item.from }}</span
                          >
                          <span
                            class="changelog__text"
                            v-show="
                              !item.description.includes('Removed') &&
                                item.from &&
                                !item.description.includes('Circuits ungrouped')
                            "
                            >to</span
                          >
                          <span
                            class="changelog__value"
                            v-if="
                              !item.description.includes('Removed') &&
                                !item.description.includes(
                                  'Circuits grouped'
                                ) &&
                                !item.description.includes('Circuits ungrouped')
                            "
                            >{{ item.to }}</span
                          >
                        </div>
                        <div class="log__details__author">
                          <span>
                            Updated by: {{ item.user.full_name }} &nbsp; ({{
                              item.user.business_name
                            }}) &nbsp; &#8226; &nbsp; {{ item.time }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div class="d-flex align-items-center my-5" v-if="isLoading">
        <b-spinner label="Loading..." variant="primary" class="mr-2" small>
        </b-spinner>
        Loading...
      </div>

      <b-list-group-item
        class="border-0 px-0 mb-5"
        v-if="!isLoading && hasMorePage"
      >
        <a href="#" @click="fetchChangelog(true)">
          View more
        </a>
      </b-list-group-item>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import SearchAll from '@/components/buttons/SearchAll'
import dayjs from 'dayjs'
export default {
  components: {
    // SearchAll
  },

  data() {
    return {
      isOpen: true,
      showHeader: true
    }
  },

  created() {
    this.getBoardDetails(this.$route.params.id)
    this.getChangelog({ id: this.$route.params.id })
  },

  computed: {
    ...mapState('board', {
      isLoading: state => state.isLoading,
      board: state => state.boardDetails,
      changelog: state => state.changelog
    }),
    hasMorePage() {
      const { meta } = this.changelog
      if (!meta) return false
      return meta.last_page > meta.current_page
    },
    latestDateUpdate() {
      if (this.changelog.data && this.changelog.data.length) {
        return dayjs
          .utc(this.changelog.data[0].created_at)
          .format('DD MMM YYYY')
          .toUpperCase()
      }
      return ''
    },
    latestTimeUpdate() {
      if (this.changelog.data && this.changelog.data.length) {
        return dayjs
          .utc(this.changelog.data[0].created_at)
          .format('H:mm a')
          .toUpperCase()
      }
      return ''
    },
    items() {
      return [
        { text: 'Home', href: '/dashboard' },
        {
          text: this.$route.params.name,
          href: this.board
            ? `/sites/${this.$route.params.name}/${this.board.site_id}`
            : ''
        },
        {
          text: this.board
            ? `${this.board.board_name}, ${this.board.location}`
            : '',
          href: this.board
            ? `/boards/${this.$route.params.name}/${this.board.board_id}`
            : ''
        },
        {
          text: 'Changelog',
          href: '#'
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      getBoardDetails: 'board/getBoardDetails',
      getChangelog: 'board/getChangelog'
    }),
    fetchChangelog(paginate = false) {
      let queryString = ''
      if (paginate) {
        queryString = `?page=${++this.changelog.meta.current_page}`
      }

      this.getChangelog({ id: this.$route.params.id, queryString })
    },
    setDescription(description) {
      return description.includes('Change Description from')
        ? 'Change Description from'
        : description.includes('Change Neutral Number from')
        ? 'Change Neutral Number from'
        : description.includes('Change Circuit Rating from')
        ? 'Change Circuit Rating from'
        : description
    }
  }
}
</script>

<style lang="scss" scoped>
.log__details__author {
  color: #6c757d;
  font-style: italic;
  font-size: 14px;
}
.custom-container {
  min-height: 500px;
}
.changelog {
  &__value {
    font-weight: bold;
    font-style: italic;
    margin: 0 8px;
  }
}
.col {
  padding: 0 12px;
  margin-bottom: 30px;
}
.btn {
  height: 46px;
  background: #ffffff33 0% 0% no-repeat padding-box;
}
.add-btn {
  height: 40px;
  width: 155px;
}
.load-btn {
  background: #f2f3f6;
  padding: 0 10px;
  border-radius: 4px;
  height: 40px;
}
.small-btn {
  width: 45%;
  font-size: 12px;
}
.empty-container {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 240px;
  text-align: center;
  padding-top: 85px;
  box-shadow: none;
}
.header-actions-container {
  position: absolute;
  color: white;
  top: 100px;
  right: 10px;
  z-index: 2;
  text-shadow: 0px 4px 8px #00000066;
}
.header-text-container {
  position: absolute;
  color: white;
  top: 100px;
  z-index: 2;
}
.header-text {
  font-size: 28px;
  font-weight: bold;
}
.subheader-container {
  background-color: #f5f5f5;
  height: 75px;
}
.subheader-text {
  font-size: 12px;
}
.subheader-text-container {
  position: absolute;
  top: 15px;
  z-index: 2;
}
.subheader-actions-container {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 2;
  text-shadow: 0px 4px 8px #00000066;
}
.cover-image {
  width: 100%;
  height: 60px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
}
.cover-overlay {
  width: 100%;
  min-height: 180px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
.breadcrumb-item {
  font-weight: bold;
}
.breadcrumb-item + .breadcrumb-item.active {
  font-weight: normal;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: '\203A';
}
.accordion > .card {
  border-radius: 8px;
}
.board-color {
  border-radius: 8px;
  height: 16px;
  width: 40px;
  margin-top: 4px;
  margin-right: 12px;
}
.toggle-btn {
  margin-top: 12px;
  font-weight: bold;
}
</style>
